// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"u4-z","colorTextValue":"v4-z","swatches":"w4-z","collapseLink":"x4-z","isCollapsed":"y4-z","dropdown":"z4-z","disabled":"A4-z"};